// 설정 해소 — 기본값 → MVP 앱 설정 → 원격 설정 (ADR-048 D4, whif-engine 해소 규칙 1~3)
//   1. 좁은 층(뒤)이 넓은 층(앞)을 덮는다
//   2. params 는 shallow merge
//   3. 어느 층에서든 enabled:false 면 비활성 — 좁은 층의 enabled:true 로 되살릴 수 없다
import type { PluginConfigEntry, PluginConfigLayer } from '../../ports/plugin-config';

const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

export interface ResolvedConfig {
  readonly enabled: boolean;
  readonly params: Readonly<Record<string, unknown>>;
}

export function resolvePluginConfig(
  name: string,
  defaults: PluginConfigEntry | undefined,
  layers: readonly PluginConfigLayer[],
): ResolvedConfig {
  const entries = [defaults, ...layers.map(layer => layer[name])].filter((e): e is PluginConfigEntry => e !== undefined);
  // 원격 층은 JSON 이다 — `__proto__` 같은 키가 Object.assign 을 거쳐 프로토타입을 바꾸지 않게 걸러 쓴다
  const params: Record<string, unknown> = {};
  for (const e of entries) {
    for (const [k, v] of Object.entries(e.params ?? {})) {
      if (!UNSAFE_KEYS.has(k)) params[k] = v;
    }
  }
  return { enabled: entries.every(e => e.enabled !== false), params };
}
